import { AxiosInstance } from "axios";
import { Role } from "../types/Role";

export const roleService = {
  getAllRoles: async (api: AxiosInstance): Promise<Role[]> => {
    try {
      const response = await api.get('/user-management/roles');
      return response.data.map((role: any) => ({
        id: role.roleId,
        label: role.roleLabel
      }));
    } catch (error) {
      console.error('Erreur lors de la récupération des rôles:', error);
      throw error;
    }
  },

  getRoleById: async (api: AxiosInstance, id: number): Promise<Role> => {
    try {
      const response = await api.get(`/user-management/roles/${id}`);
      return {
        id: response.data.roleId,
        label: response.data.roleLabel
      };
    } catch (error) {
      console.error(`Erreur lors de la récupération du rôle ${id}:`, error);
      throw error;
    }
  }
};